<script>
    import { getContext } from 'svelte';
    import NewItem from './popups/NewItem/container.svelte';
    import NewItemForm from './popups/NewItem/content.svelte';
    export let subscriptions;
  
    const { open, close } = getContext('simple-modal');
    const showPopup = () => {
          open(NewItem,
            {
                message: "add something to your group",
            },
            {
                // closeButton: CloseButton,
                form: NewItemForm,
                propsForForm: [subscriptions],
            }
        );
      };
</script>

<button 
    class="new-subscription-button primary-green" 
    on:click={showPopup}>
        New Link
</button>